import { Space, Table } from "antd"
import { centsToDollarsDisplay } from "../displayFormatters"
import DollarInput from "../common/DollarInput"
import { Action } from "./Creation/createInvoiceReducer"
import { InvoiceWorkareaGroup, PerWorkareaData } from "./Creation/createInvoiceModel"

type Props = {
  group: InvoiceWorkareaGroup
  pagination: boolean
  dispatch: (action: Action) => void
} 

const InvoiceGroupWorkareasTable = ({group, pagination, dispatch} : Props) => {
  return <Table
    rowKey='workareaId'
    dataSource={group.workareas}
    rowSelection={{
      type: 'checkbox',
      selectedRowKeys: group.workareas.filter(x => x.amount > 0).map(x => x.workareaId),
      onSelect: (workarea, selected) => {
        dispatch({ type: "WORKAREA_AMOUNT_CHANGED", value: selected ? workarea.maxBillableAmount : 0, workareaId: workarea.workareaId })
      },
      onSelectAll: () => {
        if (group.workareas.some(x => x.amount === 0)) {
          group.workareas.forEach(x => {
            if (x.amount === 0) {
              dispatch({ type: "WORKAREA_AMOUNT_CHANGED", value: x.maxBillableAmount, workareaId: x.workareaId })
            }
          })
        } else {
          group.workareas.forEach(x => dispatch({ type: "WORKAREA_AMOUNT_CHANGED", value: 0, workareaId: x.workareaId }))
        }
      }
    }}
    columns={
      [
        { title: 'Work Area', key: 'name', render: (workarea: any) => <div>
          <strong>{workarea.name}</strong> <span style={{ fontSize: '0.8em' }}>{workarea.scheduledDate}</span>
          <div style={{ fontSize: '0.8em' }}>Billable: {centsToDollarsDisplay(workarea.quotedPrice)} | Already Invoiced: {centsToDollarsDisplay(workarea.alreadyInvoiced)}</div>
        </div> },
        { title: 'Amount', key: 'amount', render: (workarea: PerWorkareaData) => <Space>
          <DollarInput 
            value={workarea.amount} 
            min={0}
            max={workarea.maxBillableAmount}
            onChange={(value) => dispatch({ type: 'WORKAREA_AMOUNT_CHANGED', workareaId: workarea.workareaId, value: value ?? 0 })}
          />
        </Space>
        }
      ]
    }
    pagination={pagination ? 
      { 
        position: ['bottomCenter'],
        pageSize: 50,
        hideOnSinglePage: true
      } : false}
    style={{ 
      width: '100%',
      maxHeight: '800px',
      overflowY: 'auto'
    }}
  />
}

export default InvoiceGroupWorkareasTable